export class FilterItemValue {

  public parentLabel: string;

  public value: string;

  public selected: boolean;


  constructor(parentLabel: string, value: string, selected: boolean) {
    this.parentLabel = parentLabel;
    this.value = value;
    this.selected = selected;
  }
}



// WEBPACK FOOTER //
// ./src/models/FilterItemValue.ts